import type { RouteLocationNormalized } from 'vue-router'

import { CUSTOM_INFO_ROUTES, type CustomInfoRoute } from '~/constants/infoRoutes'

export const validateInfoRouteCreator =
  (validRoutes: CustomInfoRoute[] = Object.values(CUSTOM_INFO_ROUTES)) =>
  ({ params }: RouteLocationNormalized) => {
    if (!params.id) return true
    return validRoutes.includes(String(params.id) as CustomInfoRoute)
  }
